import type { TutorialDefinition } from '../tutorials/types';

export const CLASS_PRESENTATION_TUTORIAL_ID = 'class-presentation';
/** 새 탭에서 이어갈 첫 단계 id */
export const CLASS_PRESENTATION_RESUME_STEP_ID = 'slide-overview';

type TutorialHandoffLike = {
  activeTutorial: TutorialDefinition | null;
  activeStepIndex: number;
  goToStepById: (stepId: string) => void;
  exitTutorial: () => void;
};

/** 수업 프레젠테이션 튜토리얼 중 「프레젠테이션 열기」면 새 탭 핸드오프 옵션을 반환한다. */
export function resolveClassPresentationSlideOpenOptions(
  tutorial: TutorialHandoffLike | null | undefined
): { tutorialId: string; tutorialStep: number } | null {
  const active = tutorial?.activeTutorial;
  if (!active || active.id !== CLASS_PRESENTATION_TUTORIAL_ID) return null;
  const step = active.steps[tutorial.activeStepIndex];
  if (!step || step.id !== 'open-presentation') return null;
  const nextIdx = active.steps.findIndex((s) => s.id === CLASS_PRESENTATION_RESUME_STEP_ID);
  return {
    tutorialId: CLASS_PRESENTATION_TUTORIAL_ID,
    tutorialStep: nextIdx >= 0 ? nextIdx : tutorial.activeStepIndex + 1,
  };
}

/** 새 탭이 열린 뒤 원래 탭 오버레이를 정리한다. */
export function finishClassPresentationHandoffOnOpener(
  tutorial: TutorialHandoffLike | null | undefined
): void {
  if (!tutorial?.activeTutorial || tutorial.activeTutorial.id !== CLASS_PRESENTATION_TUTORIAL_ID) {
    return;
  }
  tutorial.goToStepById(CLASS_PRESENTATION_RESUME_STEP_ID);
  tutorial.exitTutorial();
}
